/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinTeamBody
 */
export interface JoinTeamBody {
    /**
     * The team side to join. Required for RIVALRY. Optional for TURF_WAR if user is in only one competing hub.
     * @type {string}
     * @memberof JoinTeamBody
     */
    team?: JoinTeamBodyTeamEnum;
}


/**
 * @export
 */
export const JoinTeamBodyTeamEnum = {
    A: 'A',
    B: 'B'
} as const;
export type JoinTeamBodyTeamEnum = typeof JoinTeamBodyTeamEnum[keyof typeof JoinTeamBodyTeamEnum];


/**
 * Check if a given object implements the JoinTeamBody interface.
 */
export function instanceOfJoinTeamBody(value: object): value is JoinTeamBody {
    return true;
}

export function JoinTeamBodyFromJSON(json: any): JoinTeamBody {
    return JoinTeamBodyFromJSONTyped(json, false);
}

export function JoinTeamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinTeamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'team': json['team'] == null ? undefined : json['team'],
    };
}

export function JoinTeamBodyToJSON(json: any): JoinTeamBody {
    return JoinTeamBodyToJSONTyped(json, false);
}

export function JoinTeamBodyToJSONTyped(value?: JoinTeamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': value['team'],
    };
}

